import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { value: "" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "fv-plugins-message-container" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = { class: "row mb-6" }
const _hoisted_15 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_16 = { class: "col-lg-8 fv-row" }
const _hoisted_17 = { class: "fv-plugins-message-container" }
const _hoisted_18 = { class: "fv-help-block" }
const _hoisted_19 = { class: "row mb-6" }
const _hoisted_20 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_21 = { class: "col-lg-8 fv-row" }
const _hoisted_22 = { class: "fv-plugins-message-container" }
const _hoisted_23 = { class: "fv-help-block" }
const _hoisted_24 = { class: "row mb-6" }
const _hoisted_25 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_26 = { class: "col-lg-8 fv-row" }
const _hoisted_27 = { value: "" }
const _hoisted_28 = ["value"]
const _hoisted_29 = { class: "fv-plugins-message-container" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "row mb-6" }
const _hoisted_32 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_33 = { class: "col-lg-8 fv-row" }
const _hoisted_34 = { value: "" }
const _hoisted_35 = ["value"]
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "row mb-6" }
const _hoisted_40 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_41 = { class: "col-lg-8 fv-row" }
const _hoisted_42 = { class: "fv-plugins-message-container" }
const _hoisted_43 = { class: "fv-help-block" }
const _hoisted_44 = { class: "row mb-6" }
const _hoisted_45 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_46 = { class: "col-lg-8 fv-row d-flex flex-column gap-6 pt-3" }
const _hoisted_47 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_48 = { class: "fw-bold text-gray-700" }
const _hoisted_49 = { class: "d-flex flex-wrap gap-6" }
const _hoisted_50 = ["id", "checked", "onChange"]
const _hoisted_51 = ["for"]
const _hoisted_52 = { class: "row mb-6" }
const _hoisted_53 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_54 = { class: "col-lg-8 fv-row d-flex align-items-center pt-3" }
const _hoisted_55 = { class: "form-check form-check-custom form-check-solid" }
const _hoisted_56 = {
  class: "form-check-label",
  for: "isDefault"
}
const _hoisted_57 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_58 = {
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_59 = { class: "indicator-label" }
const _hoisted_60 = { class: "indicator-progress" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'indices'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('createNewPriceIndexDateRange')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('typeId')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "typeId",
                      class: "form-select form-select-solid form-select-lg",
                      modelValue: _ctx.selectedTypeId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedTypeId) = $event)),
                      onChange: _ctx.onTypeIdChange
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.translate('selectIndexType')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.indexTypes, (indexType) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: indexType.id,
                            value: indexType.id
                          }, _toDisplayString(indexType.name_ar), 9, _hoisted_11))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_ErrorMessage, { name: "typeId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.translate('titleAr')), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleAr",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('titleAr')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_ErrorMessage, { name: "titleAr" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.translate('titleEn')), 1),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "titleEn",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('titleEn')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_ErrorMessage, { name: "titleEn" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.translate('startYear')), 1),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "startYear",
                      class: "form-select form-select-solid form-select-lg"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_27, _toDisplayString(_ctx.translate('startYear')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearOptions, (year) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: year,
                            value: year
                          }, _toDisplayString(year), 9, _hoisted_28))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_ErrorMessage, { name: "startYear" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.translate('endYear')), 1),
                  _createElementVNode("div", _hoisted_33, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "endYear",
                      class: "form-select form-select-solid form-select-lg"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_34, _toDisplayString(_ctx.translate('endYear')), 1),
                        _createElementVNode("option", { value: _ctx.currentYear }, _toDisplayString(_ctx.translate('currentYear')) + " (" + _toDisplayString(_ctx.currentYear) + ") ", 9, _hoisted_35),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.yearOptions, (year) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: year,
                            value: year
                          }, _toDisplayString(year), 9, _hoisted_36))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_ErrorMessage, { name: "endYear" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.translate('sort')), 1),
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "sort",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('sort')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_ErrorMessage, { name: "sort" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.translate('supportedIntervals')), 1),
                  _createElementVNode("div", _hoisted_46, [
                    (!_ctx.currentViewTypes.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, _toDisplayString(_ctx.translate('selectIndexType')), 1))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentViewTypes, (vt) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: vt.id,
                        class: "d-flex flex-column gap-2"
                      }, [
                        _createElementVNode("div", _hoisted_48, _toDisplayString(vt.title_ar), 1),
                        _createElementVNode("div", _hoisted_49, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.intervals, (interval) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: interval.id,
                              class: "form-check form-check-custom form-check-solid"
                            }, [
                              _createElementVNode("input", {
                                class: "form-check-input",
                                type: "checkbox",
                                id: `interval-${vt.id}-${interval.id}`,
                                checked: _ctx.isChecked(interval.id, vt.id),
                                onChange: ($event: any) => (
                        _ctx.onIntervalViewTypeToggle(
                          interval.id,
                          vt.id,
                          $event.target.checked
                        )
                      )
                              }, null, 40, _hoisted_50),
                              _createElementVNode("label", {
                                class: "form-check-label",
                                for: `interval-${vt.id}-${interval.id}`
                              }, _toDisplayString(interval.key), 9, _hoisted_51)
                            ]))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("label", _hoisted_53, _toDisplayString(_ctx.translate('isDefault')), 1),
                  _createElementVNode("div", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "isDefault",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isDefault) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.isDefault]
                      ]),
                      _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.translate('isDefault')), 1)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_58, [
                  _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_60, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_61
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}